import React from "react";
import { useTermsStyles } from "./Terms.styles";

export const TermsHe: React.FC = () => {
  const classes = useTermsStyles();

  return (
    <div className={`${classes.root} ${classes.rtl}`}>
      {/* Main Header */}
      <h1 className={classes.mainHeader}>תנאי שימוש באתר</h1>
      <div className={classes.subMainHeader}>
        עודכן לאחרונה: 12 בדצמבר 2024.
      </div>

      {/* ======================== תנאי שימוש ======================== */}
      <section className={classes.section}>
        <p className={classes.content}>
          ברוך הבא לאתר שרון פארמס <b>("האתר")</b>. האתר משמש כחנות מקוונת
          לרכישת מוצרים שונים על ידי הציבור בישראל באמצעות האינטרנט. נא לעיין
          בתנאים אלו לפני שימוש באתר.
        </p>

        <ol className={classes.list}>
          <li>
            מפעילת האתר והשירותים המוצעים בו, ובעלת האתר, היא חברת גרסלנדס בע"מ,
            ח.פ. 517003703, שמשרדיה ממוקמים ברחוב מרים החשמונאית 44, מודיעין
            מכבים רעות (להלן: <b>"מפעיל האתר"</b> או <b>"הבעלים"</b>).
          </li>

          <li>כתובת שרון פארמס היא _____________________.</li>

          <li>
            מוצרים באתר מוצעים על ידי ספקים שונים. חלק מהמוצרים נשלחים ישירות
            מכל ספק.
          </li>

          <li>
            תנאים אלו חלים על כל שימוש של כל משתמש ו/או מבצע פעולות באתר
            <b>("לקוח")</b> ועל כל הזמנה המתבצעת באתר. לפיכך, הלקוח מתבקש לקרוא
            תנאים אלו בקפידה ולהסכים להם.
          </li>

          <li>
            כל פעולה באתר, לרבות רכישת מוצרים, מהווה את הסכמת הלקוח לתנאים אלו
            והתחייבותו לפעול על פיהם.
          </li>

          <li>
            תנאים אלו כתובים בלשון זכר מטעמי נוחות בלבד, אך מיועדים לשני המינים.
            כמו כן, הם מנוסחים ביחיד מטעמי נוחות אך תקפים גם בלשון רבים.
          </li>

          <li>
            הלקוח מצהיר כי קרא את תנאים אלו ומסכים להם. יודגש כי כל פעילות באתר
            מהווה הצהרה מוחלטת, סופית ובלתי חוזרת מצד הלקוח כי קרא, הבין והסכים
            לתנאים.
          </li>

          <li>
            מפעיל האתר רשאי למנוע גישה לאתר ו/או למנוע פעילות מכל משתמש המפר את
            תנאי האתר או עושה שימוש בלתי הולם בתכניו.
          </li>

          <li>
            מפעיל האתר ו/או החברה רשאים לעדכן ו/או לשנות את תוכן האתר, המוצרים
            והשירותים המוצעים בו, וכן את תנאים אלה, ללא הודעה מראש. שינויים
            יחולו ממועד ביצועם. ללקוח לא תהיה כל טענה ו/או תביעה בנושא.
          </li>

          <li>
            למען הסר ספק, עשויים להיות הבדלים בחוויית השימוש בין גלישה ממכשיר
            טאבלט ו/או טלפון נייד או אפליקציה לבין גלישה ממחשב שולחני או נייד.
          </li>

          <li>
            לפניות נוספות, ניתן לפנות לשירות הלקוחות של מפעיל האתר בכתובת:{" "}
            <a href="mailto:customerservice@emailexample.com">
              customerservice@emailexample.com
            </a>
            .
          </li>
        </ol>
      </section>

      {/* ======================== הזמנות באתר ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>הזמנות באתר</h2>

        <ol className={classes.list}>
          <li>
            החברה ומפעיל האתר מאפשרים ללקוחות לרכוש במהירות ובנוחות מוצרים של
            יצרנים, יבואנים וקמעונאים בישראל. האתר משמש כפלטפורמה להצגת מוצרים
            מספקים שונים, ואינו היצרן, היבואן או הקמעונאי של המוצרים.
          </li>

          <li>
            הזמנות ותשלומים מבוצעים דרך מפעיל האתר, והמוצרים נשלחים בנפרד על ידי
            כל ספק. האחריות למוצרים חלה על הספק בלבד.
          </li>

          <li>
            המוצרים באתר מיועדים לשימוש פרטי ואישי בלבד ואינם לשיווק סיטונאי.
          </li>

          <li>
            במקרה של טעות בתיאור מוצר ו/או שירות, תנאי תשלום או תמונות, רשאית
            החברה לבטל את ההזמנה לפני מסירתה ללקוח.
          </li>

          <li>
            לפני ביצוע הזמנה, על הלקוח להירשם לאתר ולהזין פרטים נכונים, מדויקים
            ומעודכנים.
          </li>

          <li>
            תשלום באתר מתבצע באמצעות כרטיסי אשראי המתקבלים בישראל כפי שמפורט
            באתר. רכישה באמצעות צ'קים, שוברים, כרטיסי מתנה, כרטיסים נטענים,
            קופונים או זיכויים — אינה מותרת אלא אם צוין אחרת.
          </li>

          <li>
            אישור הזמנה יתקבל רק לאחר אישור חברת האשראי. אם העסקה לא תאושר —
            תישלח הודעת ביטול ללקוח ולא תהיה לו כל טענה נגד מפעיל האתר, הספק או
            החברה. אם העסקה אושרה — תירשם ההזמנה וישלח אישור בדוא״ל הכולל מספר
            הזמנה, פרטי לקוח ופרטי העסקה. ללא אישור זה — אין תוקף להזמנה.
          </li>

          <li>
            רישומי מפעיל האתר מהווים ראיה לכאורה לנכונות הפעולות שבוצעו באתר.
          </li>

          <li>
            התשלום עבור כל המוצרים בהזמנה מתבצע ישירות למפעיל האתר, והחשבונית
            תונפק בעת מסירת המוצרים. שם העסק של מפעיל האתר יופיע בפירוט העסקה.
          </li>

          <li>דמי משלוח יחולו בהתאם למדיניות המשלוחים והאספקה של האתר.</li>

          <li>
            מועדי אספקה מפורטים במדיניות המשלוחים באתר. כיוון שהמוצרים נשלחים על
            ידי ספקים שונים, ייתכנו משלוחים נפרדים לאותה הזמנה.
          </li>

          <li>
            מחירי המוצרים מוצגים באתר, ודמי משלוח מוצגים במהלך תהליך הרכישה.
            לפני ביצוע ההזמנה יש להזין פרטים אישיים וכתובת למשלוח. דמי המשלוח
            עשויים להשתנות בהתאם לאזור בארץ.
          </li>

          <li>
            כל פנייה בנוגע למוצרים, משלוחים, תשלומים או ביטול עסקה — תתבצע מול
            מפעיל האתר, שיעביר אותה לגורם הרלוונטי. מפעיל האתר ו/או החברה אינם
            נושאים באחריות כלשהי למוצרים עצמם.
          </li>
        </ol>
      </section>

      {/* ======================== ביטול עסקה ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>ביטול עסקה</h2>

        <ol className={classes.list}>
          <li>
            לפי חוק הגנת הצרכן, התשמ"א–1981, לקוחות רשאים לבטל רכישות שבוצעו
            באתר בכפוף לתנאי החוק.
          </li>

          <li>
            ניתן לבטל את העסקה ממועד ביצועה ועד 14 ימים לאחר קבלת המוצר או מסמך
            פרטי העסקה — המאוחר מביניהם.
          </li>

          <li>
            עסקאות עם אנשים עם מוגבלות, אזרחים ותיקים או עולים חדשים — ניתנות
            לביטול בתוך ארבעה חודשים ממועד העסקה, קבלת המוצר או מסמך פרטי העסקה
            — המאוחר מביניהם, ובלבד שהעסקה כללה שיחה עם הלקוח. ייתכן שתתבקש הצגת
            אסמכתא.
          </li>

          <li>
            ניתן לבטל עסקאות בטלפון, בדואר רשום, בדוא"ל או באמצעות קישור "ביטול
            עסקה" באתר. מפעיל האתר רשאי לבקש פרטים לצורך אימות.
          </li>

          <li>
            מפעיל האתר רשאי לגבות דמי ביטול של עד 5% ממחיר העסקה או 100 ש"ח —
            הנמוך מביניהם.
          </li>

          <li>מפעיל האתר רשאי לתבוע נזק אם ערך המוצר פחת עקב הרעה במצבו.</li>

          <li>
            במקרה שהמוצר נשלח לפני הודעת הביטול — על הלקוח להחזירו לשרון פארמס
            לפי החוק. מפעיל האתר יסייע בתהליך ההחזרה ויציע שירות איסוף בתשלום.
          </li>

          <li>
            ביטול עקב מוצר פגום יוביל להחזרת המוצר על חשבון מפעיל האתר, לביטול
            העסקה ולהחזר כספי מלא.
          </li>

          <li>
            אין זכות ביטול למוצרים שיוצרו במיוחד עבור הלקוח או למוצרים מתכלים.
          </li>
        </ol>
      </section>

      {/* ======================== קניין רוחני ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>קניין רוחני</h2>

        <p className={classes.content}>
          כל התוכן באתר הוא קניינה הבלעדי של מפעילת האתר ו/או החברה ו/או צדדים
          שלישיים שהעניקו לה רישיון. כל העתקה, הפצה או ניצול אחר של תוכן האתר
          ללא אישור בכתב — אסורים בהחלט.
        </p>
      </section>
    </div>
  );
};
